import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import LoadingSpinner from "./LoadingSpinner";
import { ROUTES } from "../../utils/constants";

/**
 * PublicRoute Component
 *
 * Provides route protection for public/unauthenticated access.
 * Redirects authenticated users away from login pages.
 *
 * Requirements: 3.4, 3.5
 */
const PublicRoute = ({ children, redirectIfAuthenticated = true }) => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="public-route-loading">
        <LoadingSpinner />
        <p>Loading...</p>
      </div>
    );
  }

  // If user is authenticated and should be redirected
  if (redirectIfAuthenticated && isAuthenticated) {
    return <Navigate to={ROUTES.ADMIN_DASHBOARD} replace />;
  }

  // Render the public component
  return children;
};

export default PublicRoute;
